<template>
	<div>
		<div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-2 gap-y-6 sm:gap-x-4 md:gap-x-6">
			<div v-for="index in 8" :key="index">
				<div class="mb-5 skeleton-gradient w-48 h-8 mx-auto" />
				<div class="rounded-xl shadow-md skeleton-gradient aspect-[3/4]" />
				<div class="flex gap-2 mt-2 sm:mt-4">
					<div class="skeleton-gradient grow h-11 rounded-xl" />
					<div class="skeleton-gradient w-11 h-11 rounded-full" />
				</div>
			</div>
		</div>
	</div>
</template>
